import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import withPopupErrors from '../../../components/HOC/withPopupErrors/withPopupErrors';

import usePagination from '../../../lib/hooks/usePagination';
import { useFilters } from '../../../components/common/Filters/Filters';
import { selectCities } from '../../../redux/reducers/CitiesReducer';
import { selectMunicipalities } from '../../../redux/reducers/MunicipalitiesReducer';

import ActionsBar from '../../../components/common/ActionsBar/ActionsBar';
import CitiesFilters from '../../../components/admin/CitiesList/Filters';
import CreateCityForm from '../../../components/admin/CitiesList/CreationForm';
import CitiesTable from '../../../components/admin/CitiesList/Table';
import compare from '../../../lib/compare';

import plusIcon from '../../../assets/add.svg';

interface Props {
  showError: (text: string) => void;
  unauthorizedCallback: () => void;
}

const CitiesPage = ({ showError, unauthorizedCallback }: Props) => {
  const [showCreateWindow, setShowCreateWindow] = useState(false);
  const [filters, setFilter] = useFilters({ name: '', municipality: '' });

  const [sortData, setSortData] = useState({
    column: 'Название',
    descending: false,
  });

  const cities = useSelector(selectCities);
  const municipalities = useSelector(selectMunicipalities);

  const filteredAndSortedCities = Object.values(cities)
    .filter(
      (city) =>
        new RegExp(filters.name, 'i').test(city.name) &&
        new RegExp(filters.municipality, 'i').test(
          municipalities[city.municipalityId]?.name ?? '',
        ),
    )
    .sort((first, second) => {
      switch (sortData.column) {
        case 'Название':
          return compare(first.name, second.name);
        default:
          return compare(
            municipalities[first.municipalityId]?.name ?? '',
            municipalities[second.municipalityId]?.name ?? '',
          );
      }
    });

  if (sortData.descending) filteredAndSortedCities.reverse();

  const { paginator, page } = usePagination(
    Math.ceil(filteredAndSortedCities.length / 10),
  );

  const citiesForRender = filteredAndSortedCities.slice(
    (page - 1) * 10,
    page * 10,
  );

  return (
    <div style={{ display: 'flex', gap: '5rem' }}>
      <div style={{ width: '45vw', minWidth: '20rem' }}>
        <ActionsBar
          actionButtons={[
            {
              src: plusIcon,
              alt: 'Добавить город',
              placement: 'right',
              onClick: () => setShowCreateWindow(true),
            },
          ]}
        />

        <CitiesTable
          cities={citiesForRender}
          municipalities={municipalities}
          unauthorizedCallback={unauthorizedCallback}
          showError={showError}
          sortData={sortData}
          setSortData={setSortData}
        />

        {paginator}
      </div>

      <CitiesFilters filters={filters} setFilter={setFilter} />

      {showCreateWindow && (
        <CreateCityForm onClose={() => setShowCreateWindow(false)} />
      )}
    </div>
  );
};

export default withPopupErrors<Props>(CitiesPage);
